import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetComplaintDetailsAsync,
  IComplaintDetails,
} from "../../api/IComplaint";
import { RootState } from "../store";

export interface ComplaintState {
  fetchStatus: string;
  complaint?: IComplaintDetails;
}

const initialState: ComplaintState = {
  fetchStatus: "Loading...",
  complaint: undefined,
};

export const loadComplaintAsync = createAsyncThunk(
  "complaint/load",
  async (complaintId: string) => {
    const response = await GetComplaintDetailsAsync(complaintId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const complaintSlice = createSlice({
  name: "complaint",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadComplaintAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadComplaintAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.complaint = action.payload;
      });
  },
});

export const selectComplaint = (state: RootState) => state.complaint;

export default complaintSlice.reducer;
